import {InjectionToken} from '@angular/core';
import {ProductFolderRepository} from '../repositories/product-folder.repository';

export const PRODUCT_FOLDER_REPOSITORY = new InjectionToken<ProductFolderRepository>('PRODUCT_FOLDER_REPOSITORY');
